import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Field, FieldDescription, FieldGroup, FieldLabel } from '@/components/ui/field'
import { Spinner } from '@/components/ui/spinner'
import { Textarea } from '@/components/ui/textarea'

interface Props {
    open: boolean
    summary: string
    onOpenChange: (o: boolean) => void
    onPublish: (changelog: string) => Promise<void>
}

export default function PublishDialog({ open, summary, onOpenChange, onPublish }: Props) {
    const [changelog, setChangelog] = useState('')
    const [busy, setBusy] = useState(false)
    const submit = async () => {
        setBusy(true)
        try {
            await onPublish(changelog.trim())
            setChangelog('')
        } finally {
            setBusy(false)
        }
    }
    return (
        <Dialog open={open} onOpenChange={(o) => { if (!busy) onOpenChange(o) }}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Publish new version</DialogTitle>
                    <DialogDescription>
                        New submissions will use this version immediately. Existing submissions keep the version they started on. {summary}
                    </DialogDescription>
                </DialogHeader>
                <FieldGroup>
                    <Field>
                        <FieldLabel htmlFor="publish-changelog">What changed?</FieldLabel>
                        <Textarea id="publish-changelog" rows={4} value={changelog} onChange={(e) => setChangelog(e.target.value)} placeholder="Added a data residency question and a rule for cross-border transfers" />
                        <FieldDescription>Required. Shown in the version history.</FieldDescription>
                    </Field>
                </FieldGroup>
                <DialogFooter>
                    <Button variant="outline" disabled={busy} onClick={() => onOpenChange(false)}>Cancel</Button>
                    <Button disabled={busy || !changelog.trim()} onClick={() => void submit()}>
                        {busy && <Spinner data-icon="inline-start" />} Publish
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
